import { useShallow } from "zustand/react/shallow";

import { LabeledSwitch } from "components/base";

import XdaDataPicker from "../../XdaDataPicker";
import { useXdaSettingsStore } from "../../context";
import { selectXdaSettings } from "../../context/xdaSettingsSelectors";
import { XdaOptionsWrapper } from "./XdaOptionsLayout";

const XdaDataOptions = () => {
  const settings = useXdaSettingsStore(useShallow(selectXdaSettings));
  const setXdaSettings = useXdaSettingsStore((s) => s.setXdaSettings);
  const { showData } = settings;

  // sync option changes with context
  const handleSettingChange = (key) => (value) => {
    const nextSettings = { ...settings, [key]: value };
    setXdaSettings(nextSettings);
  };

  return (
    <XdaOptionsWrapper width={"400px"}>
      <LabeledSwitch
        label={{ value: "Show Data" }}
        switch={{
          isChecked: showData,
          onChange: handleSettingChange("showData")
        }}
      />
      {showData && (
        <XdaDataPicker
          initialFields={settings.dataFields}
          onChange={(fields) => {
            const nextSettings = { ...settings, dataFields: fields };
            setXdaSettings(nextSettings);
          }}
        />
      )}
    </XdaOptionsWrapper>
  );
};

export default XdaDataOptions;
